import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import AppState from './context/AppState'
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min';
// leaflet/dist/leaflet.css is now imported locally by the map-using
// components so it's only downloaded when a map page is visited.
import './utils/dayjsConfig'; // registers dayjs plugins before any component runs
import './pages/lywo/multiLang/i18n'
import './assets/css/Pristan_Css/main.scss'

// production
if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
  console.warn = () => { }
  console.info = () => { }
  console.message = () => { }
  console.verbose = () => { }
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <AppState>
      <App />
    </AppState>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
